import { render, staticRenderFns } from "./YourResponibilityCheckListTab.vue?vue&type=template&id=a1ae4688&scoped=true"
import script from "./YourResponibilityCheckListTab.vue?vue&type=script&setup=true&lang=js"
export * from "./YourResponibilityCheckListTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourResponibilityCheckListTab.vue?vue&type=style&index=0&id=a1ae4688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ae4688",
  null
  
)

export default component.exports